const golf_cart_colors = ["Green", "Silver", "Cream"];

export default golf_cart_colors;
